import { View } from "react-native";
import { Text } from "react-native-paper";
import Button from "../../components/Button";
import PopOver from "../../components/PopOver";
import { useNavigation } from "@react-navigation/native";

type ConfirmationModalProps = {
  onDismiss(): void;
  visible: boolean;
};

const ConfirmationModal = ({ onDismiss, visible }: ConfirmationModalProps) => {
  const navigation = useNavigation();
  return (
    <PopOver visible={visible} onDismiss={onDismiss}>
      <Text className="mb-2 text-regular-normal font-700 text-ink-dark">Updating your employment information.</Text>
      <Text className="text-regular-normal text-ink-dark">
        Your are being directed to your PGA Account where you will be able to update to your employment records. Once you have
        made updates, your section will need to approve the changes before you can proceed with your dues payment.
      </Text>
      <View className="flex flex-row justify-end mt-4">
        <Button size="small" onPress={onDismiss}>
          Cancel
        </Button>
        <Button
          onPress={() => {
            navigation.getParent()?.navigate("Account", { screen: "AccountEdit" });
            onDismiss();
          }}
          size="small"
          mode="secondary"
        >
          Continue to Account
        </Button>
      </View>
    </PopOver>
  );
};

export default ConfirmationModal;
